<template>
  <form @submit.prevent="" class="form-financing">
    <div class="has-financing">
      <div class="funders-table">
        <div class="form-group mb-4">
          <label for="funder">Seleccionar financiadora</label>
          <select name="funder" id="funder"
                  class="form-control search-select-funders"
                  placeholder="Seleccione la financiadora"></select>
        </div>
        <div class="form-group mb-4">
          <label for="budget">Presupuesto (M.N.): *</label>
          <input type="number"
                 name="budget"
                 id="budget"
                 class="form-control"
                 v-model="budget"
                 placeholder="$0.00"/>
        </div>
        <div class="form-group mb-4">
          <button id="add-funder" type="button"
                  class="btn btn-subtle-primary"
                  @click="addFunder"
                  :disabled="savingFunder">
            <i class="fas fa-dollar-sign mr-2"></i>
            Agregar financiadora
          </button>
        </div>
        
        <funders-table :funders="funders"
                       :amendment="amendment"
                       v-if="amendment"
                       :readonly="readonly"
                       :editable="editable"
                       :attach-agreement-function="attachAgreementToFunder"
                       :delete-funder-function="removeFunder"
                       @add-agreement="funder => this.funder = funder"
                       @funder-updated="funderUpdated"></funders-table>
      </div>
      
      <hr>
      
      <div class="form-group mb-4">
        <label for="comments">Comentarios</label>
        <textarea name="comments"
                  id="comments"
                  class="form-control"
                  placeholder="Anexe comentarios en caso de ser necesario"
                  rows="5"
                  cols="5"
                  v-if="amendment && amendment.financing_information"
                  v-model="amendment.financing_information.comments"
                  :disabled="readonly || !editable"></textarea>
      </div>
      
      <div class="my-4">
        <financing-commitments-list :amendment="amendment"
                                    :editable="editable"
                                    :editable-commitments="editableCommitments"
                                    :financing-commitments="financingCommitments"
                                    @add-financing-commitment="showAddCommitmentDialog"
                                    @remove-commitment="showRemoveCommitmentDialog"
                                    @edit-commitment="showEditCommitmentDialog"></financing-commitments-list>
      </div>
    </div>
    
    <div class="buttons-container">
      <button type="submit" class="btn btn-primary btn-lg mr-2"
              :disabled="savingFinancingInfo"
              @click="saveFinancingInformation">
        <span class="spinner-border text-yellow-500 spinner-border-sm" role="status" v-if="savingFinancingInfo">
            <span class="sr-only">Guardando...</span>
          </span>
        Guardar financiamiento
      </button>
    </div>
    
    <portal to="financing-modals">
      <financing-commitment-modal ref="financing-commitment-modal"
                                  type="amendment"
                                  :funders="funders"
                                  :selected-commitment="selectedCommitment"
                                  :add-commitment-function="addCommitment"
                                  :edit-commitment-function="editCommitment"></financing-commitment-modal>
      
      <ok-cancel-dialog id="delete-commitment-modal"
                        title="Eliminar compromiso"
                        content="<p>¿Está seguro de eliminar el compromiso contraido?</p>"
                        ok-button-text="Eliminar"
                        ok-button-type="danger"
                        @ok-button-pressed="deleteCommitment"
                        @cancel-button-pressed="commitment = null"
                        ref="delete-commitment-modal"></ok-cancel-dialog>
    </portal>
  </form>
</template>

<script>
  import FundersTable from './FundersTable'
  import FinancingCommitmentsList from './FinancingCommitmentsList'
  import FinancingCommitmentModal from './FinancingCommitmentModal'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import autosize from 'autosize'
  import { mapActions, mapGetters } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  import { find } from 'lodash'
  import 'jquery-validation'
  import 'select2'
  import 'select2/dist/js/i18n/es'
  
  export default {
    name: 'AmendmentFinancing',
    components: {
      FundersTable,
      FinancingCommitmentsList,
      FinancingCommitmentModal,
      OkCancelDialog,
    },
    props: {
      amendment: {
        type: Object,
        required: true,
      },
      editable: {
        type: Boolean,
        default: true,
      },
      editableCommitments: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      budget: '',
      selectedFunder: null,
      savingFunder: false,
      comments: null,
      otherMeans: null,
      savingFinancingInfo: false,
      commitment: null,
      funder: null,
      selectedCommitment: null,
    }),
    methods: {
      ...mapActions({
        saveAmendmentFinancing: 'amendments/saveAmendmentFinancing',
        syncFunders: 'amendments/syncFunders',
        removeFunderFromAmendment: 'amendments/removeFunder',
        saveAgreementFile: 'amendments/attachAgreementToFunder',
        getFunders: 'amendments/getAmendmentFunders',
        getFinancingCommitments: 'amendments/getFinancingCommitments',
        addFinancingCommitment: 'amendments/addFinancingCommitment',
        editFinancingCommitment: 'amendments/editFinancingCommitment',
        removeFinancingCommitment: 'amendments/removeCommitment',
      }),
      
      /**
       *
       */
      async saveFinancingInformation () {
        if (!$('.form-financing').valid()) {
          return false
        }
        
        this.savingFinancingInfo = true
        
        let response = null
        
        // Saving financing in amendment.
        response = await this.saveAmendmentFinancing({
          amendment: this.amendment,
          comments: this.amendment.financing_information.comments,
        })
        
        if (response.status === 'error') {
          AlertManager.error(response.error)
  
          this.savingFinancingInfo = false
  
          return
        }
        
        AlertManager.success(response.message)
        
        this.savingFinancingInfo = false
        
        this.$emit('saved-financing-information')
      },
      /**
       *
       * @returns {Promise<void>}
       */
      async addFunder () {
        if (this.budget && this.selectedFunder && !find(this.funders, ['id', this.selectedFunder.id])) {
          // Check if funder is not already added.
          
          const newFunders = [...this.funders]

          newFunders.push({
            id: this.selectedFunder.id,
            title: this.selectedFunder.title,
            budget: this.budget,
          })
          
          this.budget         = null
          this.selectedFunder = null
          
          this.$search.val('').trigger('change')
          
          // Save funder in server.
          const response = await this.syncFunders({
            amendment: this.amendment,
            funders: newFunders,
          })
          
          if (response.status === 'success') {
            AlertManager.success(response.message)
            
            return
          }
          
          AlertManager.error(response.error)
        }
      },
  
      async removeFunder (funder, callback) {
        const response = await this.removeFunderFromAmendment({
          amendment: this.amendment,
          funder: funder,
        })
    
        if (response.status === 'error') {
          AlertManager.error(response.error)
        }
        else {
          AlertManager.success(response.message)
        }
    
        if (callback) callback(response)
      },
      
      async attachAgreementToFunder (files) {
        const formData = new FormData()
        
        files.forEach(file => {
          formData.append('files[]', file.file)
        })
        
        formData.append('amendment_id', this.amendment.id)
        formData.append('amendment_type', this.amendment.type.key)
        formData.append('funder', this.funder.id)
        
        const response = await this.saveAgreementFile(formData)
        
        this.funder = null
        
        $('#funder-agreement-modal').modal('hide')
        
        if (response.status === 'error') {
          AlertManager.error(response.error)
          
          return
        }
        
        AlertManager.success(response.message)
      },
      
      showAddCommitmentDialog () {
        $('#financing-commitments-modal').modal('show')
      },

      showEditCommitmentDialog (commitment) {
        this.selectedCommitment = {
          id: commitment.financing_commitment_id,
          funder_id: commitment.amendment_funder_id,
          commitment_made: commitment.commitment_made,
          compliance_date: commitment.compliance_date,
        }
        
        $('#financing-commitments-modal').modal('show')
      },
      
      showRemoveCommitmentDialog (commitment) {
        this.commitment = commitment
        
        $('#delete-commitment-modal').modal('show')
      },
      
      async addCommitment (commitment, callback) {
        commitment.amendment = this.amendment
        
        const response = await this.addFinancingCommitment(commitment)
        
        if (response.status === 'success') {
          AlertManager.success(response.message)
          
          await this.getFinancingCommitments(this.amendment)
        }
        else {
          AlertManager.error(response.error)
        }
        
        if (callback) {
          callback()
        }
        
        $('#financing-commitments-modal').modal('hide')
      },

      async editCommitment (commitment, callback) {
        const response = await this.editFinancingCommitment(commitment)
        
        if (response.status === 'success') {
          AlertManager.success(response.message)
          
          await this.getFinancingCommitments(this.amendment)
        }
        else {
          AlertManager.error(response.error)
        }
        
        if (callback) {
          callback()
        }
        
        $('#financing-commitments-modal').modal('hide')
      },
  
      /**
       *
       * @returns {Promise<void>}
       */
      async deleteCommitment () {
        const {
                amendment,
                commitment,
              } = this
        
        const response = await this.removeFinancingCommitment({
          amendment,
          commitment,
        })
        
        if (response.status === 'error') {
          AlertManager.error(response.error)
          
          return
        }
        
        AlertManager.success(response.message)
        
        $('#delete-commitment-modal').modal('hide')
        
        await this.getFinancingCommitments(amendment)
      },
      
      async load () {
        await this.getFunders(this.amendment)
        await this.getFinancingCommitments(this.amendment)
      },

      async funderUpdated () {
        await this.getFunders(this.protocol)

        $("#edit-funder-file-modal").modal("hide");
      },
    },
    computed: {
      ...mapGetters({
        funders: 'amendments/funders',
        readonly: 'amendments/readonly',
        financingCommitments: 'amendments/financingCommitments',
      }),
    }
    ,
    created () {
      if (this.readonly) {
        $('.form-financing').find(':input, textarea').prop('disabled', true)
      }
    },
    async mounted () {
      const vm = this
      
      autosize($('textarea'))
      
      await this.load()
      
      if (!this.amendment.financing_information) {
        this.amendment.financing_information = {}
      }
      
      /**
       * select2 - Search funders
       */
      this.$search = $('.search-select-funders')
      this.$search.select2({
        placeholder: 'Seleccione la financiadora',
        ajax: {
          url: '/api/v1/funders',
          dataType: 'json',
          language: 'es',
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
          },
          data (params) {
            return {
              q: params.term,
              page: params.page || 1,
            }
          },
          processResults (data, params) {
            params.page = params.page || 1
            
            return {
              results: data.data,
              pagination: {
                more: (params.page * 10) < data.meta.total,
              },
            }
          },
        },
      })
      
      this.$search.on('select2:select', function (e) {
        vm.selectedFunder = e.params.data
      })
    },
  }
</script>
